
<dashboard-card [title]="'Ticket Status'" [soFarAchieved]="todaysAllAttendedTickets" [dailyTarget]="dailyTicketTarget" [diffInDays]="diffInDays" [dataItems]="dataItems"></dashboard-card>